'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
  processInclude(require('./product/detail'));
  processInclude(require('applePay/product/detail'));
  processInclude(require('mirakl/product/loadMiraklOffers'));
  processInclude(require('./product/miraklQuantityForm'));
  processInclude(require('mirakl/product/addOffer'));
});
